import TrendingNow from '../modules/TrendingNow';
import Revealer from "../modules/Revealer";
import '../web-components/mobile-hp-nav';
import '../web-components/store-location-with-map';
class IndexTemplate {
    constructor() {
        this.init();
    }
    init() {
        console.log('UNTUCKit : Template : IndexTemplate', this);
        TrendingNow.init();
        Revealer.init();
    }
}
$(() => {
    new IndexTemplate();
});
